import Analytics from './analytics';
import { deleteVideo } from './video';

if (process.env.STAGE === 'dev') {
  window.switchLive = () => {
    console.warn('Switch alla modalità diretta...');
    hideCountdown();
    showDiretta();
  };
}

/**
 * Nasconde l'area del countdown
 */
const hideCountdown = () => {
  const countdownDiv = document.querySelector('div.countdown__wrapper');
  // Prendo il player interno e lo metto in pausa
  const video = countdownDiv.querySelector('video.embed-responsive-item');
  if (countdownDiv) {
    video.pause();
    countdownDiv.classList.add('d-none');
  }
};

/**
 * Questa funzione attiva la modalità live mostrando il video della diretta.
 * return @void
 */
const showDiretta = () => {
  const direttaLive = document.querySelector('div.diretta__video');
  const contentHead = document.querySelector('div.tf22-content-head');
  const helperText = document.querySelector(
    'div.helper-text .tf22-stream-info',
  );
  if (direttaLive && contentHead) {
    direttaLive.classList.remove('d-none');
    helperText.classList.remove('d-none');
    direttaLive.parentElement.classList.add('tf22-content--stream');
    contentHead.classList.remove('tf22-content-head--sep');
  }
};

/**
 * Nasconde il video della diretta riattivando quello con gli adv
 */
const switchOff = () => {
  const direttaLive = document.querySelector('div.diretta__video');
  const contentHead = document.querySelector('div.tf22-content-head');
  const countdownArea = document.querySelector('div.countdown__wrapper');
  const helperText = document.querySelector(
    'div.helper-text .tf22-stream-info',
  );
  if (direttaLive && contentHead) {
    direttaLive.classList.add('d-none');
    helperText.classList.add('d-none');
    direttaLive.parentElement.classList.remove('tf22-content--stream');
    contentHead.classList.add('tf22-content-head--sep');
    deleteVideo();
    // Riattivo la sezione con il video adv rimuovendo l'area countdown
    countdownArea.classList.remove('d-none');
    const countdown = countdownArea.querySelector('.col-lg-7');
    const advVideo = countdownArea.querySelector('.col-lg-5');
    if (countdown && advVideo) {
      countdown.classList.add('d-none');
      advVideo.classList.remove('col-lg-5');
      advVideo.classList.add('col-lg-12');
      // avvio il video con gli adv
      advVideo.querySelector('video').play();
    }
  }
  // Come ultima azione interrompo analytics
  Analytics.stopAnalytics();
};

if (process.env.STAGE === 'dev') {
  window.switchOff = switchOff;
}

export default { hideCountdown, showDiretta, switchOff };
